/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-用户管理
 */
'use strict';
angular.module("userManagementModule",[
    'userDisplayModule',//组织用户管理-用户管理
    'userManagementRouterModule',
    'registrationAuditModule',//后台-用户管理-注册审核
    'userInformationModule',//后台-用户管理-用户信息
    'pgcUserInformationModule',//后台-用户管理-pgc用户信息
    'roleManagementModule',//后台-用户管理-角色管理
    'userManagementForRoleModule',//后台-用户管理-角色管理-用户管理
]).
controller('userManagementCtrl', ['$scope',function($scope){
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus(){
        $scope.status = {
            inputData:''
        }
    };

    function initData(){

    };
}]);